import Button, { ButtonProps } from "./Button";

type IconButtonTone = "muted" | "ink" | "none";

export interface IconButtonProps extends ButtonProps {
  tone?: IconButtonTone;
  padded?: boolean;
}

const toneClass: Record<IconButtonTone, string> = {
  muted: "text-gray-400 hover:text-gray-600",
  ink: "text-gray-900 hover:text-gray-700",
  none: "",
};

const IconButton = ({
  tone = "none",
  padded = false,
  className = "",
  ...rest
}: IconButtonProps) => {
  return (
    <Button
      variant="plain"
      size="none"
      className={`${toneClass[tone]} ${padded ? "p-2" : ""} ${className}`}
      {...rest}
    />
  );
};

export default IconButton;
